export const CONSULTATION_REPORT_INPUT_TYPES = {
  textarea: "textarea",
  patient_information: "patient_information",
  past_health_history: "past_health_history",
  mental_status_examination: "mental_status_examination",
} as const;
